<template>
    <div class="results-section">
        <h2 class="results-section-title">{{ title }}</h2>

        <div class="ml-5" v-if="!data || data.length === 0">
            <p class="text-gray-400 text-sm">{{ $t('search.no_result') }}</p>
        </div>

        <button
            v-else
            class="result-link"
            v-for="item in data"
            type="button"
            :key="item"
            @click="handleResultClick(item)"
        >
            <span v-html="highlightMatch(item)"></span>
        </button>
    </div>
</template>
<script>
export default {
    name: 'MoleculePreviewResult',
    props: {
        title: "",
        data: null,
        searchValue: ""
    },
    methods: {
        highlightMatch(text) {
            if (!this.searchValue) return text;

            const searchRegExp = new RegExp(this.searchValue, 'giu');
            return text.replace(searchRegExp, match => `<span class="text-white">${match}</span>`);
        },
        saveRecentSearch(item) {
            const recentSearch = JSON.parse(localStorage.getItem('recentSearches')) || [];
            recentSearch.unshift(item);

            const maxRecentSearchCount = 3;
            if (recentSearch.length > maxRecentSearchCount) {
                recentSearch.pop();
            }

            localStorage.setItem('recentSearches', JSON.stringify(recentSearch));
        },
        handleResultClick(item) {
            this.saveRecentSearch(item);
            const encodedItem = encodeURIComponent(item);

            this.$router.push({ path: `/search?q=${encodedItem}` });
        }
    },
}
</script>
<style scoped>
.results-section {
    @apply border-t border-gray-400 pb-5;
}

.results-section-title {
    @apply text-gray-400 text-sm p-5 pb-3 md:pb-5;
}

.result-link {
    @apply text-gray-400 hover:bg-pink hover:text-white py-1 md:py-2 px-5
    transition ease-in-out duration-200 w-full text-left;
}
</style>
